var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11.497,
    viewBox: "0 0 16 11.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "o-email_2_",
    "data-name": "o-email (2)",
    d: "M15.609,72.413h0a1.277,1.277,0,0,0-.894-.362H1.284a1.277,1.277,0,0,0-.886.355h0a1.272,1.272,0,0,0-.4.928v8.928a1.286,1.286,0,0,0,1.285,1.285H14.715A1.285,1.285,0,0,0,16,82.263V73.335a1.274,1.274,0,0,0-.39-.922Zm-5.331,5.377,5.072-4.706a.682.682,0,0,1,.047.25v8.928a.681.681,0,0,1-.047.249Zm4.437-5.138a.685.685,0,0,1,.188.027L8,79.079,4.363,75.7,1.1,72.677a.686.686,0,0,1,.18-.024ZM.648,82.512A.682.682,0,0,1,.6,82.263V73.335a.681.681,0,0,1,.05-.258l3.3,3.064,1.773,1.645Zm.636.434a.683.683,0,0,1-.19-.027L6.169,78.2,7.8,79.71a.3.3,0,0,0,.409,0L9.836,78.2,14.9,82.919a.685.685,0,0,1-.19.027Z",
    transform: "translate(0 -72.051)",
    fill: "#38d2d9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e1f41aad4d3a2feea0aad33e62a277dd.svg";
export { ForwardRef as ReactComponent };